/**
 * 公共信息模块
 */
export const is_wx = state => {
  return state.common.is_wx
}
export const is_android = state => {
  return state.common.is_android
}
export const is_mobile = state => {
  return state.common.is_mobile
}
export const new_message = state => {
  return state.common.new_message
}
export const need_jump_login = state => {
  return state.common.need_jump_login
}

export const innerHeight = state => {
  return state.common.win_height || window.innerHeight
}

export const loading_text = state => {
  return '正在加载中～'
}

export const back_path = state => {
  return state.common.back_path || ''
}

export const user_info = state => {
  return {
    id: state.userInfo.user_id,
    avatar: state.userInfo.user_avatar,
    nickname: state.userInfo.user_nickname,
    phone: state.userInfo.user_phone,
    token: state.userInfo.token
  }
}
// 是否展示切换城市
export const show_select_dialog = state => {
  var _show = false
  if (state.address.show_location_tips) {
    var _c_city = state.address.current_city || state.address.location_city
    if (!_c_city) {
      _show = 1
    } else {
      if (_c_city.indexOf('市') !== -1) {
        _c_city = _c_city.slice(0, -1)
      }
      if (state.address.open_city_name_list.indexOf(_c_city) === -1) {
        _show = 2
      }
    }
  }
  return _show
}

// 拿取城市服务电话
export const sever_phone = state => {
  var _phone = ''
  var _c_city = state.address.current_city || state.address.location_city || ''
  if (_c_city !== null && _c_city.indexOf('市') !== -1) {
    _c_city = _c_city.slice(0, -1)
  }
  if (state.address.open_city_name_object) {
    _phone = state.address.open_city_name_object[_c_city] && state.address.open_city_name_object[_c_city].phone
  }
  return _phone
}

// 企业id
export const enterprise_id = state => {
  return (state.config.enterprise_id ? (state.config.enterprise_id + '') : '') || '43'
}

// 是否登录
export const is_login = state => {
  return state.userInfo.user_phone || state.userInfo.user_id
}

export const user_phone = state => {
  return state.userInfo.user_phone || state.userInfo.user_id
}

// 用户基本信息
export const user_base_info = state => {
  return state.userInfo.user_base_info
}

// 触发更更新收藏
export const is_trigger_collect = state => {
  return state.common.is_trigger_collect
}
// 触发更新搜索列表
export const is_trigger_search = state => {
  return state.common.is_trigger_search
}

// 全局缓存变量
export const common_cache_val = state => {
  return state.common.common_cache_val
}

// 全局缓存搜索线路
export const check_search_line = state => {
  return state.common.check_search_line
}

/**
 * 地址模块
 */
// 历史地址列表
export const history_address_list = state => {
  return state.address.history_address
}

// 家庭地址
export const home_address = state => {
  var _place = state.address.location.home.address_title
  if (!_place) {
    _place = state.userInfo.user_base_info.home_place
  }
  return _place
}

// 公司地址
export const company_place = state => {
  var _place = state.address.location.company.address_title
  if (!_place) {
    _place = state.userInfo.user_base_info.company_place
  }
  return _place
}

export const search_location = state => {
  return state.address.location
}

export const current_pos_address = state => {
  return state.address.current_pos_address
}

// 热门城市列表
export const hot_city_list = state => {
  return state.address.hot_city_list
}

// 开通城市列表
export const open_city_list = state => {
  return state.address.open_city_list
}

// 当前定位城市
export const location_city = state => {
  return state.address.location_city
}

// 当前选择城市
export const current_city = state => {
  return state.address.current_city || state.address.location_city
}

// 当前定位
export const current_pos = state => {
  return state.address.current_pos
}

// 进入页面的href
export const cache_entry_href = state => {
  return state.address.cache_entry_href
}

// 是否加载完城市定位
export const is_loaded_location = state => {
  return state.address.is_loaded_location
}

// 发起线路起点
export const organize_line_start_place = state => {
  return state.address.location.organize_start.address_title
}

// 发起线路终点
export const organize_line_end_place = state => {
  return state.address.location.organize_end.address_title
}

// 链接缓存查询参数
export const link_param_cache = state => {
  return state.address.link_param_cache
}
// 链接缓存查询参数时间
export const link_param_cache_time = state => {
  return state.address.link_param_cache_time
}

/**
 * 配置模块
 */

export const home_page_nav = state => {
  return state.config.home_page_nav
}

export const commuter_sub_nav = state => {
  return state.config.commuter_sub_nav
}

export const current_nav_id = state => {
  return state.config.home_page_nav_id
}
// 选中导航栏的位置
export const current_nav_index = state => {
  return state.config.home_page_nav_index
}

/**
 * 公共信息模块
 */

// 客服电话
export const server_phone = state => {
  return state.common.server_phone
}

// 常见问题
export const qusetion_category = state => {
  return state.questions.questions
}

// search map 选中的地址
export const cache_check_address = state => {
  return state.address.cache_check_address || ''
}



// WEBPACK FOOTER //
// ./src/store/getters.js